module.exports = __webpack_public_path__ + "static/img/18018D_1_R_20200912_fit.961b652.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/18018D_1_R_20200912_fit.png
// module id = D7oR
// module chunks = 0